import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getPrivateProjectBankFileDownloadSignedUrl = async (
  projectId,
  fileId
) => {
  const apiPath = `project-bank/private/project/${projectId}/file/${fileId}/download-signed-url`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
